import * as React from 'react';
import { Navigate } from 'react-router';
import { getAccessToken } from '@/utils/accessToken';
import { isTokenExpired } from '@/utils/tokenValidation';

type Props = React.PropsWithChildren<any>;

export default function NonAuthRoute({ children }: Props) {
  const accessToken = getAccessToken({ withLocalStorage: true });

  if (accessToken && !isTokenExpired(accessToken)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
